import React, {useEffect, useState} from "react";
import {privateApiLongTimeout} from "../api";

interface ImageResponse {
    image: string;
}

interface WhatsAppLoginQrCodeProps {
    controller: boolean;
}

const WhatsAppLoginQrCode: React.FC = () => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;

        const poll = async (): Promise<void> => {
            try {
                while (!cancelled) {
                    const response = await privateApiLongTimeout.get<ImageResponse>("/cr-whatsapp-selenium-support-service/whatsapp/qr");

                    setImageSrc(
                        `data:png;base64,${response.data.image}`
                    );
                    cancelled = true; // Stop polling after receiving the image

                }
            } catch (error) {
                // Retry after a delay
                if (!cancelled) {
                    setTimeout(poll, 1000);
                }
            }
        };

        poll();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div>
            {
                imageSrc ?
                    (<img
                        src={imageSrc}
                        alt="Camera feed"
                        style={
                            {
                                maxWidth: "100%"
                            }
                        }/>) :
                    (< p> Recupero QR di configurazione...
                        </p>
                    )
            }
        </div>
    );
};

export default WhatsAppLoginQrCode;